export default __webpack_public_path__ + "static/media/duster-colour-3.d8c92c99.jpg";